import { render, staticRenderFns } from "./DateTimeAnswer.vue?vue&type=template&id=1348386e&"
import script from "./DateTimeAnswer.vue?vue&type=script&lang=ts&"
export * from "./DateTimeAnswer.vue?vue&type=script&lang=ts&"
import style0 from "./DateTimeAnswer.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports